import React, { useState, useEffect } from 'react';

const ClientDetailModal = (props) => {
    const { client, onClose, onDeleteClient, onEditClient } = props;
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState({
        name: '',
        contactPerson: '',
        email: '',
    });

    // Sync editData with client when client changes
    useEffect(() => {
        if (client) {
            setEditData({
                name: client.name || '',
                contactPerson: client.contactPerson || '',
                email: client.email || '',
            });
        }
    }, [client]);

    if (!client) return null;

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this client? This action cannot be undone.')) {
            onDeleteClient(client.id);
            onClose();
        }
    };

    const handleEdit = () => setIsEditing(true);
    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditData({ name: client.name, contactPerson: client.contactPerson, email: client.email });
    };
    const handleSaveEdit = () => {
        onEditClient(client.id, editData);
        setIsEditing(false);
    };

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.4)', backdropFilter: 'blur(8px)', padding: '1rem',
        }} onClick={onClose}>
            <div style={{
                position: 'relative', padding: '2rem', background: 'var(--color-bg)', width: '100%', maxWidth: 480, margin: 'auto', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', maxHeight: '90vh', overflowY: 'auto',
            }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--color-primary)' }}>Client Details: {client.name}</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--color-text-light)', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
                </div>
                {isEditing ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', color: 'var(--color-text)' }}>
                        <div>
                            <label style={{ display: 'block', fontSize: '1rem', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>Client Name</label>
                            <input type="text" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={editData.name} onChange={e => setEditData({ ...editData, name: e.target.value })} />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: '1rem', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>Contact Person</label>
                            <input type="text" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={editData.contactPerson} onChange={e => setEditData({ ...editData, contactPerson: e.target.value })} />
                        </div>
                        <div>
                            <label style={{ display: 'block', fontSize: '1rem', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>Email</label>
                            <input type="email" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={editData.email} onChange={e => setEditData({ ...editData, email: e.target.value })} />
                        </div>
                        <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                            <button type="button" onClick={handleCancelEdit} style={{ background: 'var(--color-secondary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Cancel</button>
                            <button type="button" onClick={handleSaveEdit} style={{ background: 'var(--color-primary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Save</button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div style={{ color: 'var(--color-text)', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <p><span style={{ fontWeight: 600 }}>Contact Person:</span> {client.contactPerson}</p>
                            <p><span style={{ fontWeight: 600 }}>Email:</span> {client.email}</p>
                            <p><span style={{ fontWeight: 600 }}>Total Projects:</span> {client.totalProjects || 0}</p>
                            <p><span style={{ fontWeight: 600, color: 'var(--color-success)' }}>Completed Projects:</span> {client.completedProjects || 0}</p>
                            <p><span style={{ fontWeight: 600, color: 'var(--color-warning)' }}>Pending Projects:</span> {client.pendingProjects || 0}</p>
                        </div>
                        <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                            <button type="button" onClick={handleEdit} style={{ background: 'var(--color-secondary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Edit</button>
                            <button type="button" onClick={onClose} style={{ background: 'var(--color-primary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Close</button>
                            {onDeleteClient && (
                                <button type="button" onClick={handleDelete} style={{ background: 'var(--color-error)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Delete Client</button>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ClientDetailModal;
